import Footer from "./Footer";
import Navbar from "./Navbar";

export const Projects = () => (
<>
<Navbar />
<section className="bg-gray-900 text-white px-6 py-28 text-center">
<h1 className="text-5xl font-extrabold">Our Completed Projects</h1>
<p className="text-xl max-w-3xl mx-auto mt-4">Premium turf installations across India for schools, academies and commercial arenas.</p>
</section>


<section className="container mx-auto px-6 py-20 space-y-16">
<article>
<h2 className="text-3xl font-bold">Full-Size Football Field — Gurugram</h2>
<p className="mt-2">Engineered base + drainage + 60mm turf + lights. Completed in 28 days.</p>
</article>


<article>
<h2 className="text-3xl font-bold">Box Cricket Arena — Noida</h2>
<p className="mt-2">High-bounce turf + custom nets + fencing + LED floodlights.</p>
</article>


<article>
<h2 className="text-3xl font-bold">School Multi-Sport Court — Jaipur</h2>
<p className="mt-2">Tennis + basketball + volleyball combined multi-sport installation.</p>
</article>
</section>
<Footer />
</>
);